import { BottomNavigation as MUIBN, BottomNavigationAction, Paper } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'
import useTranslate from '../../utils/i18n'

const BottomNavigation = ({ value, onChange, options }) => {
  const { t } = useTranslate()
  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: '16px',
        width: '100%',
        maxWidth: 'calc(444px *.7)',
        mx: '-16px',
        borderRadius: '20px',
        overflow: 'hidden',
        left: '50%',
        transform: 'translate(-46%)',
        boxShadow: '0px 3px 10px -2px rgba(0,0,0,0.2)',
      }}
      elevation={0}
    >
      <MUIBN
        showLabels
        value={value}
        onChange={(event, newValue) => {
          onChange(newValue)
        }}
      >
        {options.map((menu, idx) => (
          <BottomNavigationAction
            key={idx}
            label={t(menu.label)}
            value={menu.value}
            icon={menu.icon}
          />
        ))}
      </MUIBN>
    </Paper>
  )
}

BottomNavigation.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
}

export default BottomNavigation
